import { UserRole } from '../generated/globalTypes'

interface ErpPersonaAccessControl {
  status?: string | null
  source?: string | null
}

interface ErpPersonaUser {
  role: UserRole | string
  domain?: string | null
  isSuperAdmin?: boolean | null
  providerSubmissionStatus?: string | null
  accessControls?: (ErpPersonaAccessControl | null)[] | null
}

export const shouldEnterErp = (user?: ErpPersonaUser | null): boolean => {
  if (!user) return false

  /* As broad as the pre-groups check, which counted any access control at all.
     The one exclusion is source EVERYONE: a globally-rolled-out capability
     lands in every signed-in user's list and would make everybody staff. */
  const hasAssignedAccess = (user.accessControls ?? []).some(
    accessControl => accessControl?.status === 'ENABLED' && accessControl.source !== 'EVERYONE'
  )

  return (
    user.role !== UserRole.regular ||
    user.isSuperAdmin === true ||
    hasAssignedAccess ||
    user.providerSubmissionStatus === 'AWAITING'
  )
}

/**
 * Standard ScreenHub users with an ERP persona enter through ERP. A user with
 * a custom domain remains in that white-label CMS; ERP applies the same domain
 * exception before its own route checks, preventing a cross-application loop.
 */
export const shouldRedirectCmsEntryToErp = (user?: ErpPersonaUser | null): boolean =>
  !user?.domain && shouldEnterErp(user)
